import actions from './unitsActions'
import mutations from './unitsMutations'

export default {
  namespaced: true,
  actions,
  mutations
}